"use client";
import { jsxs as h, jsx as l } from "react/jsx-runtime";
const n = ({
  title: i,
  titleId: e,
  desc: d,
  descId: a,
  ...r
}) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-de",
    viewBox: "0 0 640 480",
    "aria-labelledby": e,
    "aria-describedby": a,
    ...r,
    children: [
      d ? /* @__PURE__ */ l("desc", { id: a, children: d }) : null,
      i ? /* @__PURE__ */ l("title", { id: e, children: i }) : null,
      /* @__PURE__ */ l("path", { fill: "#fc0", d: "M0 320h640v160H0z" }),
      /* @__PURE__ */ l("path", { fill: "#000001", d: "M0 0h640v160H0z" }),
      /* @__PURE__ */ l("path", { fill: "red", d: "M0 160h640v160H0z" })
    ]
  }
);
export {
  n as default
};
